export enum DocumentTitle {
  RSJ_ATTESTATION_SITUATION = 22,
  RSJ_ATTESTATION_RSJ = 43,
  RSJ_FIN_DROIT_AGE = 44,
  RSJ_FIN_DROIT_VERSEMENT = 45,
  RSJ_OUVERTURE_DROIT = 46,
  RSJ_RENOUVELLEMENT_APRES_SORTIE = 47,
  RSJ_REFUS_RENOUVELLEMENT = 48,
  RSJ_REFUS_ELIGIBILITE = 49,
  RSJ_REPONSE_SUSPENSION = 50,
}
